<template>
  <div>
    <div class="loading" v-if="loading">
      Loading...
    </div>

    <div v-if="error" class="error">
      {{ error }}
    </div>

    <ul class="studio-list">
      <li v-for="studio in studios" class="studio" :key="studio._id">
        <StudioTile :studio='studio'></StudioTile>
      </li>
    </ul>
  </div>
</template>

<script>
import sanity from "../sanity";
import imageUrlBuilder from "@sanity/image-url";
import StudioTile from '../components/StudioTile.vue';

const imageBuilder = imageUrlBuilder(sanity);

const query = `*[_type == "studio"] {
  _id,
  name,
  website,
  color,
  "scenes": *[_type=='scene' && references(^._id)]{
    _id,
    name,
    studios,
    thumbnail,
    studios[]->,
  }
}[0...50] |  order(name asc)`;

export default {
  name: "Studios",
  data() {
    return {
      loading: true,
      studios: [],
    };
  },
  components: {
    StudioTile
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    imageUrlFor(source) {
      return imageBuilder.image(source);
    },
    fetchData() {
      this.error = this.post = null;
      this.loading = true;
      sanity.fetch(query).then(
        studios => {
          this.loading = false;
          this.studios = studios;
        },
        error => {
          this.error = error;
        }
      );
    }
  }
};
</script>

<style scoped>
.studio-list {
  display: grid;
  margin: 0;
  padding: 36px;
  grid-gap: 36px;
  grid-template-columns: 1fr 1fr;
  list-style: none;
}
.scene-tile__preview-container img {
  width: 100%;
}
</style>
